import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PatientService } from 'src/app/services/patient.service';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import {
  ApiResult,
  PromiseResult,
  ServerError
} from '../../../models/PromiseResult';
import { DoctorReports } from '../../../models/patient-consultation';
import { reportspdf } from 'src/app/models/reportspdf';
import { TraceClassDecorator } from '@sentry/angular';
import { saveAs } from 'file-saver';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { URLS } from 'src/app/constant/constant';


// import { PrescriptionComponent } from 'src/app/components/shared/prescription/prescription.component';
interface patient {
  first_name: string;
  middle_name: string;
  last_name: string;
  age: number;
  date_of_birth: Date;
  gender: string;
}
interface reports {
  id: number;
  consultation_date: string;
  prescription_key: string;
  reports_key: string;
  prescription_url: string;
  reports_url: string;
  consultation_request_number: string;
  consultation_name: string;
  consultation_id: number;
  speciality: string;
  referred_to_nutritionist_boolean: boolean;
  referred_to_nutritionist_value: string;
  doctor_name: string;
}
@Component({
  selector: 'app-doctor-reports',
  templateUrl: './doctor-reports.component.html',
  styleUrls: [
    './doctor-reports.component.css',
    '../../../../assets/css/custom-egd.css',
    '../../../../assets/css/print-prescription.css'
  ]
})
@TraceClassDecorator()
export class DoctorReportsComponent implements OnInit {
  displayModel: boolean = false;
  displayModel1: boolean = false;
  selectMemeber = null;
  members_list = [];
  memberdata_list = [];
  member = '';
  SelectedMemberName = '';
  c_data = [];
  DR_data = [];
  doctor_reports: reports[] = [];
  data;
  medical_conditions;
  members_data;
  loading: boolean = true;
  loading1: boolean = true;
  display3: boolean = false;
  response: PromiseResult;
  serverError: ServerError;
  posting: boolean;
  prescription_url: string = '';
  reports_url: string = '';
  prescription_key: string = '';
  reports_key: string = '';
  api_url: string = '';
  consultations: DoctorReports[];
  patient: patient;
  consultation_id: number;
  patient_guid: string;
  report_type: string;
  showPrescription: string = 'showPrescription';
  showDoctorReports: string = 'showDoctorReports';
  printContent: string = 'print-content';
  showPrescriptiond: string = 'showPrescription';
  showDoctorReportsd: string = 'showDoctorReports';
  prescriptionData: reportspdf;
  prescriptionApiResult: ApiResult = new ApiResult();
  patient_cur_guid: string;
  doctorReportsData: reportspdf;
  doctorReportsApiResult: ApiResult = new ApiResult();
  result: PromiseResult;
  slug: string = "";
  is_uk_country: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly titleService: Title,
    private readonly patientservice: PatientService,
    private readonly providerstateService:ProviderStateService
  ) {
    
    this.posting = false;
  }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerstateService.getProviderSlug();
    if(URLS.IS_UK)
    {
      this.is_uk_country = true;
    }
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'patient'] },
      { label: 'Reports' }
    ]);
    this.response = {
      success: null,
      error: null,
      data: null
    };
    this.serverError = {
      statusCode: null,
      error: null,
      message: null
    };
    this.consultations = [];

    this.members_data = [];
    this.members_list = [];
    this.memberdata_list = [];
    this.patient = {
      first_name: '',
      middle_name: '',
      last_name: '',
      age: 0,
      date_of_birth: null,
      gender: ''
    };

    await this.getMemberList();
    this.SetTitle('Dashboard -  Doctors Report');
  }

  private async ResetResultModels(): Promise<void> {
    this.response = {
      success: null,
      error: null,
      data: null
    };
    this.serverError = {
      statusCode: null,
      error: null,
      message: null
    };
  }

  SetTitle(title: string) {
    this.titleService.setTitle(title);
  }

  async getMemberList() {
    let temp = [];
    this.posting = true;
    await this.ResetResultModels();
    await this.patientservice
      .getMember(sessionStorage.getItem('userid'))
      .toPromise()
      .then((result) => {
        this.response = result;
        if (result.success) {
          this.memberdata_list = result.data.patient;
          for (let i = 0; i < result.data.patient.length; i++) {
            temp.push({
              label:
                ' ' +
                result.data.patient[i].first_name +
                ' ' +
                (result.data.patient[i].middle_name==null?'':result.data.patient[i].middle_name) +
                ' ' +
                result.data.patient[i].last_name +
                ' ',
              value: result.data.patient[i].patient_guid
            });
          }
          this.members_list = temp;
        }
        this.posting = false;
      });
  }

  async GetDoctorReports(patient_guid: string) {
    this.ResetResultModels();
    await this.patientservice
      .GetDoctorReports(this.member)
      .toPromise()
      .then((result: PromiseResult) => {
        this.result = result;
        let temp: reports[] = [];
        if (result.success) {
          this.result.data.forEach((ele, index) => {
            temp.push({
              id: index + 1,
              consultation_date: ele.consultation_date,
              prescription_key: ele.consultation_reports.prescription_key,
              reports_key: ele.consultation_reports.reports_key,
              prescription_url: ele.consultation_reports.prescription_url,
              reports_url: ele.consultation_reports.reports_url,
              consultation_request_number: ele.consultation_request_number,
              speciality: ele.p_consultation_appointment
                .map((speciality) => {
                  return speciality.d_specialty_type.specialty_name;
                })
                .join(','),
              consultation_id: ele.id,
              referred_to_nutritionist_boolean: ele.referred_to_nutritionist,
              referred_to_nutritionist_value: ele.referred_to_nutritionist
                ? 'Yes'
                : 'No',
              doctor_name: ele.p_consultation_appointment
                .map((doc) => {
                  return (
                    doc.egd_users.first_name + ' ' + doc.egd_users.last_name
                  );
                })
                .join(','),
              consultation_name: ele.priority_type.consultation_name
            });
          });
        }
        this.doctor_reports = temp;
        this.posting = false;
      });
  }

  async onChange() {
    this.member = this.selectMemeber.value;
    this.SelectedMemberName = this.selectMemeber.label;
    this.doctor_reports = this.DR_data;
    this.medical_conditions = [];
    this.members_data = [];
    this.patient = {
      first_name: '',
      middle_name: '',
      last_name: '',
      age: 0,
      date_of_birth: null,
      gender: ''
    };

    for (const patient of this.memberdata_list) {
      if (patient.patient_guid == this.member) {
        this.patient.first_name = patient.first_name;
        this.patient.middle_name = patient.middle_name;
        this.patient.last_name = patient.last_name;
        this.patient.date_of_birth = new Date(
          patient.date_of_birth.replace(/-/g, '/')
        );
        this.patient.age = Math.min(
          new Date().getFullYear() - this.patient.date_of_birth.getFullYear(),
          0
        );
        this.patient.gender = patient.gender;
        await this.GetDoctorReports(this.member);
      }
    }
  }

  private async GetPrescriptionData() {
    await this.patientservice
      .GetDoctorReportspdf(
        this.patient_guid,
        this.consultation_id,
        'prescription'
      )
      .toPromise()
      .then((result) => {
        this.prescriptionApiResult.PromiseResult = result;
        if (result.success) {
          this.response = result;
          this.prescriptionData = result.data;
        }
      });
  }

  private async GetDoctorReportsData() {
    await this.patientservice
      .GetDoctorReportspdf(this.patient_guid, this.consultation_id, 'report')
      .toPromise()
      .then((result) => {
        this.doctorReportsApiResult.PromiseResult = result;
        if (result.success) {
          this.response = result;
          this.doctorReportsData = result.data;
        }
      });
  }

  async CloseDialog(): Promise<void> {
    this.displayModel = false;
    this.displayModel1 = false;
  }

  print() {
    window.print();
  }

  // async gotoReportpdf(consultation_id: number) {
  //     this.patient_guid = this.member;
  //     this.consultation_id = consultation_id;
  //     await this.GetDoctorReportsData();
  //     this.displayModel1 = true;
  // }

  // async gotoprescription(consultation_id: number) {
  //     this.patient_guid = this.member;
  //     this.consultation_id = consultation_id;
  //     await this.GetPrescriptionData();
  //     this.displayModel = true;
  // }

  async getReportBase64(api_url: string) {
    this.api_url = api_url;
    await this.patientservice
      .GetBase64FromUrl(this.api_url)
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.downloadFile(result.data.base64, result.data.filename);
        }
      });
  }

  downloadFile(base64Data: string, filename: string) {
    // Convert base64 to a Blob
    const byteCharacters = atob(
      base64Data.replace(/^data:application\/pdf;base64,/, '')
    );
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(blob, filename);
  }

  RouterNavigation(path: string) {
    this.router.navigate([path]);
  }
}
